import { MEDIA_TYPE } from '@whatsper/texterchat-common';
import React from 'react';
import MessengerMessageLabel from './components/MessengerMessageLabel';
import FeedComment from './components/FeedComment';
import FeedReaction from './components/FeedReaction';
import ViewOnFacebookPost from './components/ViewPostOnFacebook';
import PostPreview from './components/PostPreview';
import styles from './MessengerMessage.module.scss';
const MessengerMessage = ({ message, direction }) => {
    var _a;
    const post = (_a = message.feedReaction) === null || _a === void 0 ? void 0 : _a.post;
    const previewUrl = (post === null || post === void 0 ? void 0 : post.video) ? post.video : post === null || post === void 0 ? void 0 : post.photo;
    const previewType = (post === null || post === void 0 ? void 0 : post.video) ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE;
    return (React.createElement("div", { className: styles.messageContainer },
        React.createElement("div", { className: styles.messageHeader },
            React.createElement(MessengerMessageLabel, { message: message, direction: direction }),
            React.createElement(ViewOnFacebookPost, { message: message }),
            message.feedComment && React.createElement(FeedComment, { feedComment: message.feedComment }),
            message.feedReaction && React.createElement(FeedReaction, { feedReaction: message.feedReaction })),
        previewUrl && React.createElement(PostPreview, { url: previewUrl, type: previewType })));
};
export default MessengerMessage;
